import React from "react";
import "./How_Bespoke_Gifting_Works_card.css";

function How_Bespoke_Gifting_Works_card({ number, title, desc }) {
  return (
    <>
      <section className="How_Bespoke_Gifting_Works_card">
        <div className="card_inner">
          <div className="number_holder">
            <div className="number_text_holder">
              <h2>{number}</h2>
            </div>
          </div>

          <div className="text_hodler">
            <h1>{title}</h1>
            <p>{desc}</p>
          </div>
        </div>
      </section>
    </>
  );
}

export default How_Bespoke_Gifting_Works_card;
